import getYear from '../get-year';
import getDate from '../get-date';
import getHours from '../get-hours';
import getMonth from '../get-month';
import getSeconds from '../get-seconds';
import getMinutes from '../get-minutes';
import getMonthName from '../get-month-name';

const formatters: { [index: string]: (date: Date, substring: string) => string | number } = {
  d: (date: Date, substring: string) => {
    const day = getDate(date);

    switch (substring) {
      case 'd':
        return day;

      case 'dd':
        return day < 10 ? `0${day}` : day;

      default:
        return substring;
    }
  },
  h: (date: Date, substring: string) => {
    const hours = getHours(date);

    switch (substring) {
      case 'h':
        return hours;

      case 'hh':
        return hours < 10 ? `0${hours}` : hours;

      default:
        return substring;
    }
  },
  M: (date: Date, substring: string) => {
    const month = getMonth(date) + 1;

    switch (substring) {
      case 'M':
        return month;
      case 'MM':
        return month < 10 ? `0${month}` : month;
      case 'MMMM':
        return getMonthName(date);

      default:
        return substring;
    }
  },
  m: (date: Date, substring: string) => {
    const minutes = getMinutes(date);

    switch (substring) {
      case 'm':
        return minutes;

      case 'mm':
        return minutes < 10 ? `0${minutes}` : minutes;

      default:
        return substring;
    }
  },
  s: (date: Date, substring: string) => {
    const seconds = getSeconds(date);

    switch (substring) {
      case 'ss':
        return seconds < 10 ? `0${seconds}` : seconds;

      default:
        return substring;
    }
  },
  y: (date: Date, substring: string) => {
    const year = getYear(date);

    switch (substring) {
      case 'y':
        return year;

      case 'yyyy':
        return year;

      default:
        return substring;
    }
  }
};

export const formatDate = (date: Date, format: string) => {
  const tokenRegExp = /[MmHh]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

  return format
    .match(tokenRegExp)
    ?.map((substring) => {
      const firstChar = substring[0];

      const formatter = formatters[firstChar];

      return formatter ? formatter(date, substring) : substring;
    })
    .join('');
};

export default formatDate;
